import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

const SubsidiesApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.SUBSIDIES}
        scope='subsidies'
        envKey={apps[AppId.SUBSIDIES].runtimeEnvKey}
        entryPath='./SubsidiesApp'
        url={process.env.REACT_APP_SUBSIDIES_APP_DEV_PATH}
        appName={apps[AppId.SUBSIDIES].name}
        appProps={{
          user,
          history: history,
          appPath: apps[AppId.SUBSIDIES].path,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)

export { SubsidiesApp }
